import { render, staticRenderFns } from "./suggestionsListAdder.vue.html?vue&type=template&id=13ddb068&"
import script from "./suggestionsListAdder.ts?vue&type=script&lang=ts&"
export * from "./suggestionsListAdder.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports